module.exports = __webpack_public_path__ + "static/media/clock-regular.75bdb9fe.svg";